<template>
  <el-select v-model="cate_id" filterable @change="changeHandle">
    <el-option :value="0" label="全部"></el-option>
    <el-option
      v-for="(cate, cateKey) in cateList"
      :label="cate.name"
      :value="cate.id"
      :key="cateKey"
    ></el-option>
  </el-select>
</template>

<script>
  import http from '@/lib/admin/http'

  export default {
    name: "cateOption",
    props:{
        placeholder:{
            default:'请选择'
        },
        value:{
            require:true
        }
    },
    data() {
      return {
        cateList:[],
          cate_id: 0
      }
    },
      watch: {
          value(value) {
              this.cate_id = value
          },
          cate_id(value) {
              this.$emit('input', value)
          }
      },
    methods: {
      getcateList (){
        let vthis = this;
        http.getData(this.$store.state.cate.url, {all:true})
          .then(res =>{
            vthis.cateList = res.data.list
          })
      },
      changeHandle (){
        this.$emit('input', this.cate_id)
      }
    },
    created() {
      this.cate_id = this.value;
      this.getcateList()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/cate/CateOption.vue